// Fashion & Beauty V1: tenant department context. Hardware tenants resolve to isFashion=false with no departments.
import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

let cache = null;
let inflight = null;
const listeners = new Set();

export const fetchDepartments = async (force = false) => {
  if (cache && !force) return cache;
  if (!inflight) {
    inflight = api.get("/departments").then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); return cache; })
      .catch(() => { cache = { is_fashion: false, departments: [] }; return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export function useFashion() {
  const { business } = useAuth();
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (!business?.is_fashion) { setData({ is_fashion: false, departments: [] }); return undefined; }
    listeners.add(setData);
    fetchDepartments().then(setData);
    return () => listeners.delete(setData);
  }, [business?.is_fashion]);
  const reload = useCallback(() => fetchDepartments(true), []);
  const departments = data?.departments || [];
  return {
    isFashion: !!business?.is_fashion,
    ready: !!data,
    departments,
    active: departments.filter((d) => !d.archived),
    byKey: (k) => departments.find((d) => d.key === k),
    reload,
  };
}

export const attrSummary = (dept, attrs = {}) => {
  const order = [...(dept?.attributes || []).map((a) => a.key), ...Object.keys(attrs).filter((k) => !(dept?.attributes || []).some((a) => a.key === k))];
  return order.filter((k) => attrs[k]).map((k) => attrs[k]).join(" · ");
};

export { imgSrc } from "@/lib/img";
